﻿import { AxiosInstance } from "axios";
import { getContentType, getFileName, triggerDownload } from "helpers";
import { createLogger } from "logging";

const logger = createLogger("DownloadApi");

export class DownloadApi {
  constructor(private axios: AxiosInstance) {}

  async handleDownload(url: string, fileName: string): Promise<void> {
    try {
      const response = await this.axios.get(url, {
        responseType: "blob",
        withCredentials: true,
      });

      const responseFileName = getFileName(response, fileName);
      const responseContentType = getContentType(response);
      triggerDownload(response.data, responseFileName, responseContentType);
    } catch (error) {
      logger.error("Failed to download file", error);
      throw error;
    }
  }
}
